import styled from 'styled-components';

import {
  BodySmallRegular,
  BodyStandardMedium,
  BodyStandardSemiBold,
  Colour,
} from '@xemplo/style-constants';

export const UploadContainer = styled.div`
  ${BodyStandardMedium};
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Label = styled.label`
  color: ${Colour.Gray[700]};
  margin: 0;
  ${BodyStandardMedium};
`;

export const FileInput = styled.input`
  color: ${Colour.Gray[400]};
  ${BodySmallRegular};
  &::file-selector-button {
    color: ${Colour.Gray[500]};
    ${BodyStandardSemiBold};
    border: 1px solid ${Colour.Gray[200]};
    border-radius: 24px;
    background: none;
    padding: 8px 16px;
    margin-right: 10px;
    cursor: pointer;
    &:hover {
      color: ${Colour.Gray[600]};
      background: ${Colour.Gray[50]};
    }
  }
`;
